"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
require("../../src/modules/search");
var datatable_1 = __importDefault(require("../../src/modules/datatable"));
var hothy_table_1 = __importDefault(require("../../src/modules/datatable/hothy_table"));
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var zw_mutiplestock_1 = __importDefault(require("../../src/modules/datatable/zw_mutiplestock"));
var dataurl_1 = __importDefault(require("../../src/modules/datatable/dataurl"));
var dataconfig_1 = __importDefault(require("../../src/modules/datatable/dataconfig"));
window["tableconfigdatas"] = { tablecolumns: dataconfig_1["default"], tabledataurl: dataurl_1["default"] };
initInfos();
function initInfos() {
    getContent();
    //机构一致看多个股 
    zw_mutiplestock_1["default"]();
    //热门行业追踪
    var hotinds_table = new hothy_table_1["default"]({
        table_type: 'zw_indshotindustry',
        div_id: 'zw_hotindustry_table',
        pager_id: '',
        tableclass: 'zw_table',
        initParams: {
            fid: 'f3',
            fs: 'm:90 t:2',
            fields: 'f12,f13,f14,f3,f128' //需要返回的字段 14板块名称 128领涨股票
        },
        onShowComplete: function () {
            //pagehyhq('zw_indshotinds_table')
        }
    });
}
function getContent() {
    // let encodeUrl = util.getUrlParams('encodeUrl');
    // if (encodeUrl == '' || encodeUrl == null) return;
    var publishDate = zwinfo.notice_date ? zwinfo.notice_date : ''; //时间
    var newDate = utils_1["default"].getchinesedate(publishDate);
    var orgName = zwinfo.source_sample_name; //机构名称
    var orgcode = zwinfo.company_code; //机构代码
    $("#publish-date").text(newDate);
    $(".link-neweast").attr('href', "orgpublish.jshtml?orgcode=" + orgcode + "&orgname=" + encodeURIComponent(orgName));
    //最新策略报告
    var stratyge_table = new datatable_1["default"]({
        table_type: 'zw_stratyge',
        div_id: 'zw_stratyge_table',
        pager_id: '',
        tableclass: 'zw_table',
        initParams: {
            orgCode: orgcode
        },
        columns: {
            config: [
                {
                    width: 310,
                    th: function name(v) {
                        return '标题';
                    },
                    td: function (v) {
                        return "<a href='/report/zw_strategy.jshtml?encodeUrl=" + v.encodeUrl + "'>" + v.title + "</a>";
                    }
                },
                {
                    width: 76,
                    th: function name(v) {
                        return '报告日期';
                    },
                    td: function (v) {
                        return v.publishDate.slice(0, 11);
                    }
                },
                {
                    width: 76,
                    th: function name(v) {
                        return '机构名称';
                    },
                    td: function (v) {
                        return "<a href='/report/orgpublish.jshtml?orgcode=" + v.orgCode + "'>" + v.orgSName + "</a>";
                    }
                },
                {
                    width: 156,
                    th: function name(v) {
                        return '研究员';
                    },
                    td: function (v) {
                        var arr = v.researcher.split(',');
                        if (arr.length < 4) {
                            return "<span>" + v.researcher + "</span>";
                        }
                        else {
                            return "<span title=\"" + arr.join(',') + "\">" + arr.slice(0, 3).join(',') + "...</span>";
                        }
                    }
                },
            ]
        },
    });
    //最新研究报告
    var neweast_table = new datatable_1["default"]({
        table_type: 'zw_neweast',
        div_id: 'zw_neweast_table',
        pager_id: '',
        tableclass: 'zw_table',
        initParams: {
            // qType:2
            orgCode: orgcode
        },
        columns: {
            config: [
                {
                    width: 310,
                    th: function name(v) {
                        return '标题';
                    },
                    td: function (v) {
                        return "<a href='/report/zw_strategy.jshtml?encodeUrl=" + v.encodeUrl + "'>" + v.title + "</a>";
                    }
                },
                {
                    width: 76,
                    th: function name(v) {
                        return '报告日期';
                    },
                    td: function (v) {
                        return v.publishDate.slice(0, 11);
                    }
                },
                {
                    width: 76,
                    th: function name(v) {
                        return '机构名称';
                    },
                    td: function (v) {
                        return "<a href='/report/orgpublish.jshtml?orgcode=" + v.orgCode + "'>" + v.orgSName + "</a>";
                    }
                },
                {
                    width: 156,
                    th: function name(v) {
                        return '研究员';
                    },
                    td: function (v) {
                        var arr = v.researcher.split(',');
                        if (arr.length < 4) {
                            return "<span>" + v.researcher + "</span>";
                        }
                        else {
                            return "<span title=\"" + arr.join(',') + "\">" + arr.slice(0, 3).join(',') + "...</span>";
                        }
                    }
                },
            ]
        },
    });
}
;
